import {TabController} from "../../vendor/tabs";

if(document.getElementById('product-tabs')) {
    const productTabs = new TabController('#product-tabs');
}
